import { toRGBA } from "./utils";

const snagglepuss = [252, 207, 200];
const s = (opacity: number = 1) =>
  toRGBA(snagglepuss[0], snagglepuss[1], snagglepuss[2], opacity);

export default s;
